import { Badge } from '@/components/ui/badge';
import { formatBlogDate, getShareUrls } from '@/lib/blog';
import { cn } from '@/lib/utils';
import { Post } from '@/types/model';
import { Calendar, Clock } from 'lucide-react';
import { RichContentRenderer } from '../seo-content-renderer';

interface BlogDetailContentProps {
  post: Post;
  className?: string;
}

export function BlogDetailContent({ post, className }: BlogDetailContentProps) {
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const shareUrls = getShareUrls(currentUrl, post.title);

  return (
    <>
      {/* Featured Image Hero */}
      {/* {post.featured_image && (
        <img
          src={getBlogImageUrl(post.featured_image, 'blog')}
          alt={post.title}
          className="mx-auto aspect-[1200/628] h-full max-h-[500px] w-full rounded-b-2xl object-cover object-center shadow-xl"
        />
      )} */}
      <article className={cn('mx-auto max-w-4xl py-8', className)}>
        {/* Post Metadata */}
        <div className="mb-6 flex flex-wrap items-center gap-3">
          {post.category && (
            <Badge variant="default" className="text-sm">
              {post.category.name}
            </Badge>
          )}
          <div className="text-muted-foreground flex items-center gap-1.5 text-sm">
            <Calendar className="h-4 w-4" />
            <span>{formatBlogDate(post.published_at || '')}</span>
          </div>
          {post.reading_time && (
            <div className="text-muted-foreground flex items-center gap-1.5 text-sm">
              <Clock className="h-4 w-4" />
              <span>{post.reading_time} phút đọc</span>
            </div>
          )}
        </div>

        {/* Title */}
        <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl">{post.title}</h1>

        {/* Excerpt */}
        {post.excerpt && <p className="text-muted-foreground mb-6 text-xl leading-relaxed">{post.excerpt}</p>}

        {/* Tags */}
        {post.tags && post.tags.length > 0 && (
          <div className="mb-8 flex flex-wrap gap-2">
            {post.tags.map((tag) => (
              <Badge key={tag.id} variant="outline">
                #{tag.name}
              </Badge>
            ))}
          </div>
        )}

        {/* Rich Content */}
        <div className="mb-12">
          {/* <RichContentRenderer editorSerializedState={post.content} /> */}
          <RichContentRenderer
            editorSerializedState={JSON.parse(post.content)}
            className="prose prose-gray max-w-none transition-all duration-1000"
          />
        </div>

        {/* Gallery Images */}
        {/* {post.gallery_images && post.gallery_images.length > 0 && (
        <div className="mb-12 grid grid-cols-1 md:grid-cols-2 gap-4">
          {post.gallery_images.map((image, index) => (
            <div key={index} className="relative aspect-video rounded-lg overflow-hidden shadow-md">
              <img
                src={getBlogImageUrl(image, 'blog')}
                alt={`${post.title} - Hình ${index + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      )} */}
      </article>
    </>
  );
}
